export default {
    Search: {
        btns: {
            protein: '蛋白质',
            nucleotide: '核苷酸',
            nucleotideDb: '核苷酸数据库',
            proteinDb: '蛋白质数据库',
            upload: '上传序列',
            delete: '删除',
            clear: '清除',
            addFragment: '添加片段',
        },
        propver: {
            reset: '重置',
            Preferences: {
                qconv: {
                    1: '查询覆盖范围设置越高，命中序列的相似度越高。',
                    2: '设置查询覆盖范围以设定返回序列的最低匹配长度的百分比，若需要搜索整段序列，推荐设置高覆盖范围。',
                },
                gaps: {
                    1: '匹配间隙仅仅修改了序列对齐的BLAST分数，并不一定会增加或减少返回结果。',
                    2: '设置是否包含间隙进行匹配意味着您是否希望序列对齐结果中包含间隙。若序列中某些片段十分相似但被一些不匹配部分所隔开，则推荐开启匹配间隙：',
                    3: '专利可以在一定的百分比范围内保护序列，无论有无间隙，因此两种模式都值得尝试。',
                },
                evalue: {
                    1: 'E-Value期望阈值设置越高，返回结果可能越多。',
                    2: 'E-Value代表命中结构与查询序列偶然相似的可能性。例如，如果查询序列很短，则其偶然出现在序列不同位置的可能性将很高。E-Value设置得越高，这种偶然性就越大。',
                },
                algorithm: {
                    megaBlast: '适用于比较非常相似的序列。',
                    blastn: '标准核苷酸检索，在核苷酸库中匹配核苷酸序列。',
                    blastnShort: '适用于长度短于50个核苷酸的短序列。',
                    blastxFast: '将待查询的核苷酸序列翻译成蛋白质序列，然后在蛋白质库中进行匹配。',
                    blastpFast: '使用较长字长，相较于标准Blastp用时较短。',
                    blastp: '标准蛋白质检索，在蛋白质库中匹配蛋白质序列。',
                    blastpShort: '适用于长度短于30个氨基酸的短序列。',
                    tblastnFast:
                        '将待查询的核苷酸库中的核苷酸序列翻译成蛋白质序列后，将待查询的蛋白质与翻译结果进行匹配。',
                },
                lowComplexRegion: '屏蔽查询序列中的低复杂度区域。',
                defaultAlgorithm: '输入短序列，算法将调整为blast-short',
                slowWarning: '蛋白序列搜索核酸库会花费较长时间！',
            },
        },
        labels: {
            refinements: '搜索选项',
            predicted: '序列类型:',
            database: '选择数据库:',
            advance: '高级设置 >',
            sequenceLength: '序列长度',
            preferences: '搜索偏好设置',
            countries: '国家',
            countriesTitle: '请选择国家/组织/地区',
            similarity: '序列相似度 (%)',
            qconv: '查询覆盖范围 (%)',
            gaps: '匹配间隙',
            evalue: 'E-Value',
            algorithm: '算法',
            matrix: '打分矩阵',
            wordSize: '匹配字长',
            wordSizeHold: '默认',
            gapCosts: '间隙罚分',
            matchScores: '匹配得分／ <br/> 错配罚分',
            matchScoresNoWrap: '匹配得分／错配罚分',
            proAutoAdjust:
                '自动调整短序列的搜索参数，若勾选此项，则在查询等于或短于30个氨基酸的序列时自动调整到blastp-short算法。',
            nuAutoAdjust:
                '自动调整短序列的搜索参数，若勾选此项，则在查询短于50个核苷酸的序列时自动调整到blastn-short算法。',
            threshold: '期望阈值',
            yes: '是',
            no: '否',
            queryIdentity: '查询相似度 (%)',
            subjectIdentity: '目标相似度 (%)',
            subjectCoverage: '目标覆盖范围 (%)',
            subjectLength: '目标序列长度',
            subjectProteinLength: '目标长度（蛋白）',
            subjectNucLength: '目标长度（核酸）',
            targetSeqLimit: '序列检索上限',
            targetSeqLimitTooltip: '请联系客服升级权限',
            length: '长度',
            multi: '多段',
            lowComplexRegion: '忽略低复杂度区域',
            defaultAlgorithm: '默认算法',
            searchParameters: '检索偏好',
            algorithmSettings: '算法设置',
            databaseTitle: '数据库',
            mismatch: '错配数',
        },
        explanation: {
            example: '示例',
            identityLength: '相似序列长度',
            alignLength: '对齐区域长度',
            queryLength: '查询序列长度',
            subjectLength: '目标序列长度',
        },
    },
};
